import { gql } from "@apollo/client"

const GET_TIMETABLE_SUMMARY = gql`
  query($input: SessionTimetableSummaryInput!) {
    sessionTimetableSummary(input: $input) {
      id
      total_absent
      total_attended
      total_available
      total_booked
      total_disabled
      total_slots
    }
  }
`

export { GET_TIMETABLE_SUMMARY }
